import React from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";

const GroupWiseReportV2 = ({ list, loading, isSite = false }) => {
  if (loading) {
    return (
      <div className="dashboard-v2__table-section">
        <Skeleton height={28} width={360} />
        <Skeleton height={220} className="mt-3" />
      </div>
    );
  }

  return (
    <section className="dashboard-v2__table-section">
      <h2 className="dashboard-v2__table-title">
        Group wise <span>Unhealthy State</span> report
      </h2>
      <div className="dashboard-v2__table-wrap">
        <div className="table-responsive">
          <table className="table dashboard-v2__table mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Groups</th>
                <th>{isSite ? "Site" : "Machine"}</th>
                <th>Site Owner</th>
                <th>Unhealthy Records</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index) => (
                <tr key={`${item.id}-${index}`}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="sites-v2__tags">
                      {item.group.map((e) => (
                        <span key={e.uuid} className="sites-v2__tag machines-v2__tag">
                          {e.name}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td>
                    <Link to={isSite ? `/site-info/${item.id}` : `/machine-info/${item.id}`} className="dashboard-v2__link">
                      {item.machine}
                    </Link>
                  </td>
                  <td className="dashboard-v2__owner-cell">
                    <strong>{item.owner.name}</strong>
                    <small>{item.owner.email || item.owner.uid}</small>
                  </td>
                  <td>{item.unhealthyCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default GroupWiseReportV2;
